import { render, staticRenderFns } from "./EditImage.vue?vue&type=template&id=35363e26&scoped=true&"
import script from "./EditImage.vue?vue&type=script&lang=ts&"
export * from "./EditImage.vue?vue&type=script&lang=ts&"
import style0 from "./EditImage.vue?vue&type=style&index=0&id=35363e26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35363e26",
  null
  
)

export default component.exports